/**
 * Calculates SHA-256 hash of file contents. This is intended to be used in the browser.
 * @param arrayBuffer The file contents to calculate the hash for
 * @param windowObj The window object (optional, defaults to global window)
 * @returns A promise that resolves to the hash as a hex string, or null if the crypto API is not available
 */
export const calculateFileHash = async (
  arrayBuffer: ArrayBuffer,
  windowObj: Window & typeof globalThis = window
): Promise<string | null> => {
  // Check if crypto API is available
  if (!windowObj.crypto || !windowObj.crypto.subtle) {
    console.warn('Crypto API is not available in this browser');
    return null;
  }

  try {
    const hashBuffer = await windowObj.crypto.subtle.digest(
      'SHA-256',
      arrayBuffer
    );
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
  } catch (error) {
    console.error('Hash calculation error:', error);
    return null;
  }
};
